document.addEventListener('DOMContentLoaded', function () {
  var audio = document.getElementById('r4o-audio');
  var playBtn = document.getElementById('r4o-playbtn');
  var iconPlay = document.getElementById('r4o-icon-play');
  var iconPause = document.getElementById('r4o-icon-pause');
  var message = document.getElementById('r4o-message');
  var progress = document.getElementById('r4o-progress');
  var current = document.getElementById('r4o-current');
  var duration = document.getElementById('r4o-duration');

  if (!audio || !playBtn) return;

  function formatTime(s) {
    var m = Math.floor(s / 60);
    var sec = Math.floor(s % 60);
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  playBtn.addEventListener('click', function () {
    if (audio.paused) {
      audio.play();
      iconPlay.style.display = 'none';
      iconPause.style.display = 'block';
      if (message) { message.style.opacity = '1'; }
    } else {
      audio.pause();
      iconPlay.style.display = 'block';
      iconPause.style.display = 'none';
      if (message) { message.style.opacity = '0'; }
    }
  });

  audio.addEventListener('timeupdate', function () {
    if (audio.duration) {
      var pct = (audio.currentTime / audio.duration) * 100;
      if (progress) progress.style.width = pct + '%';
      if (current) current.textContent = formatTime(audio.currentTime);
    }
  });

  audio.addEventListener('loadedmetadata', function () {
    if (duration) duration.textContent = formatTime(audio.duration);
  });

  audio.addEventListener('ended', function () {
    iconPlay.style.display = 'block';
    iconPause.style.display = 'none';
    if (progress) progress.style.width = '0%';
    if (current) current.textContent = '0:00';
    if (message) message.style.opacity = '0';
  });

  var progressBar = progress ? progress.parentElement : null;
  if (progressBar) {
    progressBar.addEventListener('click', function (e) {
      var rect = progressBar.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var pct = x / rect.width;
      audio.currentTime = pct * audio.duration;
    });
  }
});
